/* This is the Firebase configuration file */

import Firebase from 'firebase'
import config from './config'

let app = Firebase.initializeApp(config)
let db = app.database()

// create a database references
const settingsRef = db.ref('settings')
const pagesRef = db.ref('pages')
const booksRef = db.ref('books')
const textsRef = db.ref('texts')
const categoriesRef = db.ref('categories')
const featuredRef = db.ref('featured')
const authorsRef = db.ref('authors')
const postsRef = db.ref('posts')
const usersRef = db.ref('users')
const mediaRef = db.ref('media')
const navRef = db.ref('nav')

export { booksRef, textsRef, featuredRef, categoriesRef, authorsRef, postsRef, usersRef, settingsRef, pagesRef, mediaRef, navRef }



// WEBPACK FOOTER //
// ./src/firebase_config/index.js